import React from 'react';
import './Products.css';

const Products = () => {
  const products = [
    {
      title: 'Chatbot con IA',
      description: 'Guía inteligente para crear tu Business Model Canvas paso a paso',
      features: ['Asistencia 24/7', 'Personalización según tu negocio', 'Análisis de viabilidad']
    },
    {
      title: 'Generador Kanban con IA',
      description: 'Tableros de tareas generados automáticamente según las necesidades de tu negocio',
      features: ['Generación automática', 'Priorización inteligente', 'Seguimiento en tiempo real']
    },
    {
      title: 'Plataforma de Aprendizaje',
      description: 'Charlas, eventos y cursos sobre emprendimiento y transformación digital',
      features: ['Contenido exclusivo', 'Eventos en vivo', 'Comunidad de emprendedores']
    },
    {
      title: 'Modelos de Analítica',
      description: 'Machine Learning para toma de decisiones estratégicas basadas en datos',
      features: ['Predicciones precisas', 'Dashboards interactivos', 'Análisis predictivo']
    },
    {
      title: 'Consultoría en Transformación',
      description: 'Automatización y optimización de procesos operativos',
      features: ['Análisis de procesos', 'Roadmap personalizado', 'Implementación guiada']
    },
    {
      title: 'Fábrica de Software',
      description: 'Desarrollo de aplicaciones web y móviles a medida',
      features: ['Diseño personalizado', 'Desarrollo ágil', 'Soporte continuo']
    }
  ];

  return (
    <section id="productos" className="products">
      <div className="products-container">
        <div className="section-header">
          <h2 className="section-title">Nuestros Productos</h2>
          <p className="section-subtitle">
            Soluciones diseñadas para cada etapa de tu negocio
          </p>
        </div>

        <div className="products-grid">
          {products.map((product, index) => (
            <div key={index} className="product-card">
              <h4 className="product-title">{product.title}</h4>
              <p className="product-description">{product.description}</p>
              <ul className="product-features">
                {product.features.map((feature, idx) => (
                  <li key={idx}>
                    <span className="check-icon">✓</span>
                    {feature}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Products;

